class FCMService {
  static async initialize(): Promise<string | null> {
    console.log('[FCMService:web] initialize noop');
    return null;
  }

  static async getToken(): Promise<string | null> {
    console.log('[FCMService:web] getToken noop');
    return null;
  }

  static async validateAndUpdateToken(): Promise<void> {
    console.log('[FCMService:web] validateAndUpdateToken noop');
  }

  static async saveUserToken(_userId: string, _token: string): Promise<void> {
    console.log('[FCMService:web] saveUserToken noop');
  }

  static setupTokenRefreshListener(_userId: string): () => void {
    console.log('[FCMService:web] setupTokenRefreshListener noop');
    return () => {
      console.log('[FCMService:web] teardown noop');
    };
  }

  static async sendPushNotification(_fcmToken: string, _payload: { title: string; body: string; data?: Record<string, any> }): Promise<void> {
    console.log('[FCMService:web] sendPushNotification noop');
  }

  static async sendPushNotificationToUser(_params: {
    targetUserId: string;
    title: string;
    body: string;
    data?: Record<string, any>;
  }): Promise<void> {
    console.log('[FCMService:web] sendPushNotificationToUser noop');
  }
}

export default FCMService;
export { FCMService };
